<template>
  <loading :active="loading"
           :can-cancel="true"
           :on-cancel="onCancel"
           :is-full-page="true">
  </loading>
  <!-- 후원 추천인 찾기 모달 팝업 -->
  <div class="w-full p-1 justify-between ">
    <div class="text-right"><span @click="close_pid_search"  class="cursor-pointer p-2 font-semibold text-gray-800">X</span></div>
    <h2 class="w-full text-lg xl:text-xl lg:text-xl font-semibold text-gray-800 border-l-[10px] border-[#4493d5] pl-3">
      後援者確認
      <div class="text-[#2c7fc3] text-xs font-semibold">( チェックボックスをクリックして選択してください。 )</div>
    </h2>
  </div>

  <div class="w-full p-2 mb-24 md:mb-4">
    <div class="w-full p-1 justify-between " ref="lineContainer" id="tree_wrap">
      <section class="m-[10px]">
        <div class="w-full flex flex-col lg:flex-row justify-start lg:space-x-4 lg:py-2 lg:items-center mb-4">
          <div class="w-full lg:w-1/6 text-base font-semibold mb-2">会員番号/会員名</div>
          <div class="w-full lg:w-5/6">
            <input name="p_id" id="p_id" class="h-10 xl:w-60 lg:w-60 w-full" @input="toUpper" v-model="search_pid" maxlength='40' type="text">
            <input type="button" @click="getPidList"  class="h-10 xl:w-36 lg:w-36 w-full leading-6 text-white bg-[#172e59] hover:bg-[#0e1b35] transition duration-200 cursor-pointer mt-2 xl:ml-2 lg:mt-0 xl:mt-0" value="確認"/>
          </div>
        </div>
      </section>
      <h4 class="line_sub_tit mt_20"></h4>
      <!-- S : 회원 검색 리스트 -->
      <div class="mt-8 mb-8" style="position:relative;" v-if="search_info.length > 0">
        <table class="search_result_table w-full">
          <tbody >
          <tr>
            <th class="select_th">Select</th>
            <th>会員番号 (会員名)</th>
          </tr>
          <tr v-for="(row) in search_info" @click="searchPid(row.userid)">
            <td class="select_td">
              <div class="table_checkbox" >
                <input type="checkbox" :id="'checkbox_' + row.userid" name="select_pid" class="blind" v-model="search_pid" :value="row.userid" @click="searchPid(row.userid)">
              </div>
            </td>
            <td>{{ row.userid }} ({{ row.username }})</td>
          </tr>
          </tbody>
        </table>
      </div>
      <!-- E : 회원 검색 리스트 -->
      <h4 class="line_sub_tit mt_20"></h4>
      <Tree v-if="treeData.length > 0" :nodes="treeData" :use-checkbox="true" :use-icon="true" show-child-count @nodeClick="onNodeClick"/>
      <div v-else>検索結果はありません。</div>
    </div>
  </div>

</template>

<script>
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import VueSimpleAlert from "vue3-simple-alert";
import Tree from 'vue3-tree';
import 'vue3-tree/dist/style.css';

export default {
  name: "pidSearch",
  components : {
    Loading,
    Tree
  },

  data: () => ({
    i18n        : window.i18n,
    loading     : false,
    r_id        : window.Laravel.registerRid,
    r_name      : window.Laravel.registerRname,
    search_info : [], // 후원인 검색시 사용
    search_pid  : window.Laravel.registerRid ?? "", // 검색된 후원인으로 Tree의 기준점이 됨
    treeData    : [],
  }),
  created() {
    this.searchPid(window.Laravel.registerRid);
  },
  methods : {
    // 추천인 산하 후원인 Tree 가져오기
    searchPid(pid) {
      this.loading     = true;
      this.search_info = [];

      axios.post(window.Laravel.back_url+'/api/getPidTree',{
        start_id   : this.r_id,
        search_pid : pid,
      }, {headers: {Authorization: 'Bearer ' + window.Laravel.access_token}})
        .then(response => {
          const result = response.data;

          if (result === -1) { // 추천인 아이디나 검색할 아이디가 없을 경우
            VueSimpleAlert.alert("推薦者会員番号はありません。","","",{allowOutsideClick : false}).then((result) => {});
            this.treeData = [];
          } else if (result === -5) { // 추천인 산하를 벗어난 아이디 검색은 허용하지 않음
            VueSimpleAlert.alert("正しい会員番号または名前を入力してください。 (推薦者の傘下会員のみ選択可能)","","",{allowOutsideClick : false}).then((result) => {});
            this.treeData = [];
          } else if (result === 99) { // api 쿼리 에러
            VueSimpleAlert.alert("検索結果はありません。[99]","","",{allowOutsideClick : false}).then((result) => {});
            this.treeData = [];
          } else {
            this.treeData = this.makeTreeNode(result);
          }
          this.loading = false;

        })
    },

    // 후원인 Tree 구조에 맞게 데이터 가공
    makeTreeNode(data = '') {
      if (!data) {
        return [];
      }

      const transformedData = [];

      // 노드를 추가하는 함수
      const addNode = (item, parentNode) => {
        const currentNode = parentNode.nodes.find(node => node.userid === item.userid);

        // 현재 노드가 존재하지 않으면 새로 추가
        if (!currentNode) {
          const newNode = {
            id      : item.userid,
            label   : item.userid + " (" + item.username + ")",
            userid  : item.userid,
            username: item.username,
            nodes   : []
          };
          parentNode.nodes.push(newNode);
          return newNode; // 새로 추가한 노드를 반환
        }

        return currentNode; // 이미 존재하는 노드를 반환
      };

      // 하위 노드 추가를 위한 재귀 함수
      const addChildNodes = (parentItem, parentNode) => {
        data.forEach(innerItem => {
          // 하위노드 아이디가 있을 경우 추가
          if (innerItem.up_id === parentItem.userid) {
            const childNode = addNode(innerItem, parentNode);
            // 하위 노드가 추가되면 그 하위 노드에 대해 재귀 호출
            addChildNodes(innerItem, childNode);
          }
        });
      };

      // 모든 아이템을 처리
      data.forEach(item => {
        if (!item.userid) {
          return; // userid가 없으면 건너뜀
        }

        // lev가 1인 경우는 최상위 노드로 추가
        if (parseInt(item.lev) === 1) {
          const topNode = {
            id      : item.userid,
            label   : item.userid + " (" + item.username + ")",
            userid  : item.userid,
            username: item.username,
            nodes   : []
          };
          transformedData.push(topNode);
          // 최상위 노드에 대해 하위 노드 추가
          addChildNodes(item, topNode);
        }
      });

      return transformedData;
    },

    // 추천인 아이디 기준으로 후원인 검색하여 관련 회원 리스트 추출 (아이디 / 이름 검색 가능)
    getPidList() {
      if (!this.search_pid) {
        VueSimpleAlert.alert("会員番号または会員名を入力して検索してください。","","",{allowOutsideClick : false}).then((result) => {});
      }

      this.loading = true;
      axios.post(window.Laravel.back_url+'/api/pidsearch',{
        start_id   : this.r_id,
        search_pid : this.search_pid,
      }, {headers: {Authorization: 'Bearer ' + window.Laravel.access_token}})
        .then(response => {
          const result = response.data;

          if (result === -1) { // 추천인 아이디나 검색할 아이디가 없을 경우
            VueSimpleAlert.alert("会員番号または会員名を入力して検索してください。[-1]","","",{allowOutsideClick : false}).then((result) => {});
            this.search_info = [];
          } else if (result === 99) { // api 쿼리 에러
            VueSimpleAlert.alert("検索結果はありません。[99]","","",{allowOutsideClick : false}).then((result) => {});
            this.search_info = [];
          } else {
            this.search_info = result;
          }
          this.loading = false;

        });

    },

    close_pid_search() {
      this.$emit("close_pid_search");
    },
    toUpper() {
      this.search_pid = this.search_pid.toUpperCase();
    },
    onNodeClick(node) {
      // 체크박스로 선택한 아이디를 기준으로 후원인 추가
      if (node.checked) {
        this.$emit("set_pid", { userid: node.userid, username: node.username });
      }
    }

  }
}
</script>
<style>
/*검색결과 테이블*/
.search_result_table{}
.search_result_table tr{background:#fff; cursor: pointer;}
.search_result_table tr:hover, .search_result_table tr:focus{background:rgb(3 15 38 / 10%);}
.search_result_table tr:nth-child(odd){background:#f3f4f5;}
.search_result_table tr:nth-child(odd):hover, .search_result_table tr:nth-child(odd):focus{background:#eee;}
.search_result_table tr th{min-width: 140px; background:#d6deeb; padding:8px 10px; text-align: center; font-size: 15px; word-break: break-word; font-weight: 500; color:#333;}
.search_result_table tr td{min-width: 140px; padding:8px 10px;  text-align: center; font-size: 14px; word-break: break-word; color:#444;}
/*테이블 셀렉트 체크박스일 경우*/
.search_result_table tr .select_th{min-width: 100px; background:#d6deeb; padding:8px 10px; text-align: center; font-size: 15px; word-break: break-word; font-weight: 500; color:#333;}
.search_result_table tr .select_td{min-width: 100px; padding:8px 10px;  text-align: center; font-size: 14px; word-break: break-word; color:#444;}
.search_result_table .select_btn{min-width: 100px; border: 1px solid #000; border-radius: 10px; padding: 5px; background: #000; color: #fff;  word-break: break-word;}

/*검색결과 리스트 형식일 경우*/
.search_result_list{margin-top:20px;}
.search_result_box{display:flex; flex-wrap: wrap; border-top:1px dashed #c3c3c3;}
.search_result_box:hover, search_result_box:focus{background:rgb(3 15 38 / 10%); box-sizing:border-box; cursor:pointer;}
.search_result_box:last-child{border-bottom:1px dashed #c3c3c3;}
.search_result_box .table_checkbox{padding:10px; display: flex; align-items: center; flex-direction: column; justify-content: center; min-width:60px; width:70px; border-right: 1px solid #ddd;}
.search_result_box .table_checkbox svg, .search_result_box .check_select_btn i{font-size:20px; color:#c8c8c8;  transition: all 0.2s ease-in-out;}
.search_result_box:hover .table_checkbox svg, .search_result_box:hover .check_select_btn i, .search_result_box:hover label{color:#13264b;  transition: all 0.1s ease-in-out;}
.search_result_dl{padding: 10px 0  10px 10px; width: calc(100% - 70px);}
.search_result_dl dt{display:flex;}
.search_result_dl dd{}
.search_result_dl dd .result_tit{ color: #333; font-size: 15px; font-weight: 500;}
.search_result_dl dd .result_cont{color:#444; font-size: 14px; font-weight: 400;}
/*checkbox 간격 조정*/
div.tree div.tree-row-item input[type=checkbox] { margin: 0 8px; }

.modal-card {
  position: relative;
  max-width: 90%;
  max-height: 600px;
  width: 100%;
  padding: 20px;
  background-color: white;
  z-index: 999;
  opacity: 1;
  overflow-y: auto;
  border-radius: 20px;
  top:50%;
  left:50%;
  transform: translate(-50%, -50%);
}
</style>
